/**
 * `cn`: une nombres de clase de forma condicional.
 *
 * Helper mínimo para componer `className` (clases base + variantes + las que
 * llegan por props) sin arrastrar una dependencia nueva. Filtra valores
 * falsy y une con espacio. No deduplica ni resuelve conflictos de Tailwind:
 * los componentes de `ui/` ponen las clases base primero y dejan que las de
 * `className` ganen por orden, que es suficiente para esta librería.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
